// Curated blog posts. Each article links to a real, authoritative external source.
// Video cards use real YouTube tutorial IDs.
export const BLOG_POSTS = [
  {
    id: "zero-trust-nist",
    category: "cyber",
    image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=1200&q=80",
    youtube: null,
    url: "https://csrc.nist.gov/pubs/sp/800/207/final",
    readTime: 12,
    date: "2025-12-08",
    featured: true,
    fr: { title: "Zero Trust Architecture — NIST SP 800-207", excerpt: "Le document fondateur du National Institute of Standards and Technology qui définit l'architecture Zero Trust. La référence à lire avant tout projet de modernisation de la sécurité." },
    en: { title: "Zero Trust Architecture — NIST SP 800-207", excerpt: "The foundational publication from the National Institute of Standards and Technology that defines Zero Trust architecture. The must-read reference before any security modernization project." },
    es: { title: "Zero Trust Architecture — NIST SP 800-207", excerpt: "La publicación fundacional del NIST que define la arquitectura Zero Trust. La referencia obligada antes de cualquier proyecto de modernización de seguridad." },
    zh: { title: "零信任架构 — NIST SP 800-207", excerpt: "美国国家标准与技术研究院定义零信任架构的奠基性出版物。开展任何安全现代化项目前的必读参考。" },
  },
  {
    id: "nis2-enisa",
    category: "cyber",
    image: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=1200&q=80",
    youtube: null,
    url: "https://www.enisa.europa.eu/topics/cybersecurity-policy/nis-directive-new",
    readTime: 8,
    date: "2025-11-18",
    featured: false,
    fr: { title: "Directive NIS2 — Guide officiel de l'ENISA", excerpt: "L'Agence européenne pour la cybersécurité publie sa lecture officielle de la directive NIS2 : périmètre, obligations, sanctions et calendrier de mise en œuvre." },
    en: { title: "NIS2 Directive — Official ENISA guidance", excerpt: "The European Union Agency for Cybersecurity publishes its official reading of the NIS2 directive: scope, obligations, sanctions and implementation timeline." },
    es: { title: "Directiva NIS2 — Guía oficial de ENISA", excerpt: "La Agencia de la Unión Europea para la Ciberseguridad publica su lectura oficial de la directiva NIS2: alcance, obligaciones, sanciones y calendario." },
    zh: { title: "NIS2 指令 — ENISA 官方指南", excerpt: "欧盟网络安全局发布对 NIS2 指令的官方解读:范围、义务、处罚与实施时间表。" },
  },
  {
    id: "rag-anthropic",
    category: "ai",
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=1200&q=80",
    youtube: null,
    url: "https://www.anthropic.com/news/contextual-retrieval",
    readTime: 9,
    date: "2025-12-02",
    featured: false,
    fr: { title: "Contextual Retrieval — l'évolution du RAG par Anthropic", excerpt: "Anthropic présente une technique qui réduit drastiquement les erreurs de récupération dans les pipelines RAG. Méthodologie, benchmarks et code d'exemple inclus." },
    en: { title: "Contextual Retrieval — Anthropic's evolution of RAG", excerpt: "Anthropic introduces a technique that drastically reduces retrieval failures in RAG pipelines. Methodology, benchmarks and sample code included." },
    es: { title: "Contextual Retrieval — la evolución del RAG por Anthropic", excerpt: "Anthropic presenta una técnica que reduce drásticamente los fallos de recuperación en pipelines RAG. Metodología, benchmarks y código incluido." },
    zh: { title: "Contextual Retrieval — Anthropic 对 RAG 的演进", excerpt: "Anthropic 介绍一种大幅降低 RAG 流水线检索失败率的技术,包含方法、基准与示例代码。" },
  },
  {
    id: "apache-iceberg",
    category: "bigdata",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&q=80",
    youtube: null,
    url: "https://iceberg.apache.org/",
    readTime: 6,
    date: "2025-11-25",
    featured: false,
    fr: { title: "Apache Iceberg — Documentation officielle", excerpt: "Time travel, schema evolution, ACID : la documentation de référence du format de table qui redéfinit le lakehouse moderne." },
    en: { title: "Apache Iceberg — Official documentation", excerpt: "Time travel, schema evolution, ACID: the reference documentation for the table format that is redefining the modern lakehouse." },
    es: { title: "Apache Iceberg — Documentación oficial", excerpt: "Time travel, evolución de esquema, ACID: la documentación de referencia del formato de tabla que redefine el lakehouse moderno." },
    zh: { title: "Apache Iceberg — 官方文档", excerpt: "时间旅行、模式演化、ACID:重新定义现代 Lakehouse 的表格式参考文档。" },
  },
  {
    id: "platform-engineering",
    category: "it",
    image: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=1200&q=80",
    youtube: null,
    url: "https://platformengineering.org/blog/what-is-platform-engineering",
    readTime: 7,
    date: "2025-11-04",
    featured: false,
    fr: { title: "Qu'est-ce que le Platform Engineering ?", excerpt: "La communauté platformengineering.org publie la définition de référence : IDP, golden paths, self-service. Le tournant majeur dans l'ingénierie logicielle." },
    en: { title: "What is Platform Engineering?", excerpt: "The platformengineering.org community publishes the reference definition: IDP, golden paths, self-service. The major turning point in software engineering." },
    es: { title: "¿Qué es el Platform Engineering?", excerpt: "La comunidad platformengineering.org publica la definición de referencia: IDP, golden paths, self-service. El gran giro de la ingeniería de software." },
    zh: { title: "什么是平台工程?", excerpt: "platformengineering.org 社区发布参考定义:IDP、黄金路径、自助式。软件工程的重大转折点。" },
  },
  {
    id: "finops-kubernetes",
    category: "it",
    image: "https://images.unsplash.com/photo-1667372393119-3d4c48d07fc9?w=1200&q=80",
    youtube: null,
    url: "https://www.finops.org/framework/",
    readTime: 8,
    date: "2025-10-28",
    featured: false,
    fr: { title: "Le Framework FinOps — Maîtriser ses coûts cloud", excerpt: "Le standard publié par la FinOps Foundation : domaines, capacités et personas. La grille de lecture pour reprendre le contrôle de sa facture cloud." },
    en: { title: "The FinOps Framework — Master your cloud costs", excerpt: "The standard published by the FinOps Foundation: domains, capabilities and personas. The reading grid to regain control over your cloud bill." },
    es: { title: "El Framework FinOps — Domine sus costes cloud", excerpt: "El estándar publicado por la FinOps Foundation: dominios, capacidades y personas. La rejilla para recuperar el control de su factura cloud." },
    zh: { title: "FinOps 框架 — 掌控您的云成本", excerpt: "FinOps 基金会发布的标准:领域、能力与角色。重新掌控云账单的解读框架。" },
  },

  // === Video tutorials (YouTube content is the article) ===
  {
    id: "rag-tuto",
    category: "ai",
    image: "https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=1200&q=80",
    youtube: "T-D1OfcDW1M",
    url: null,
    readTime: 18,
    date: "2025-12-05",
    featured: false,
    fr: { title: "Tutoriel — Construire un RAG en production", excerpt: "Tutoriel vidéo pas à pas pour mettre en place un pipeline RAG robuste avec embeddings, re-ranking et observabilité." },
    en: { title: "Tutorial — Build a RAG in production", excerpt: "Step-by-step video tutorial to set up a robust RAG pipeline with embeddings, re-ranking and observability." },
    es: { title: "Tutorial — Construir un RAG en producción", excerpt: "Tutorial en vídeo paso a paso para montar un pipeline RAG robusto con embeddings, re-ranking y observabilidad." },
    zh: { title: "教程 — 构建生产级 RAG", excerpt: "分步视频教程:用向量检索、重排序与可观测性搭建稳健的 RAG 流水线。" },
  },
  {
    id: "llmops-tuto",
    category: "ai",
    image: "https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=1200&q=80",
    youtube: "5p248yoa3oE",
    url: null,
    readTime: 22,
    date: "2025-11-10",
    featured: false,
    fr: { title: "Tutoriel — Observer ses LLMs en production", excerpt: "Drift, hallucinations, coûts : tutoriel vidéo pour instrumenter ses LLMs dès le jour 1." },
    en: { title: "Tutorial — Observe your LLMs in production", excerpt: "Drift, hallucinations, costs: video tutorial to instrument your LLMs from day 1." },
    es: { title: "Tutorial — Observar sus LLMs en producción", excerpt: "Drift, alucinaciones, costes: tutorial en vídeo para instrumentar sus LLMs desde el día 1." },
    zh: { title: "教程 — 在生产中观测 LLM", excerpt: "漂移、幻觉、成本:从第一天起埋点 LLM 的视频教程。" },
  },
  {
    id: "k8s-cost-tuto",
    category: "it",
    image: "https://images.unsplash.com/photo-1667372393119-3d4c48d07fc9?w=1200&q=80",
    youtube: "kImST7wAOLA",
    url: null,
    readTime: 25,
    date: "2025-10-28",
    featured: false,
    fr: { title: "Tutoriel — Réduire sa facture Kubernetes", excerpt: "Right-sizing, spot, bin-packing, FinOps. Tutoriel vidéo pour comprimer durablement vos coûts cloud." },
    en: { title: "Tutorial — Cut your Kubernetes bill", excerpt: "Right-sizing, spot, bin-packing, FinOps. Video tutorial to durably compress your cloud costs." },
    es: { title: "Tutorial — Reducir su factura Kubernetes", excerpt: "Right-sizing, spot, bin-packing, FinOps. Tutorial en vídeo para reducir sus costes cloud." },
    zh: { title: "教程 — 削减 Kubernetes 账单", excerpt: "合理调度、Spot、Bin-packing、FinOps。持续压缩云成本的视频教程。" },
  },
];
